module.exports = __webpack_public_path__ + "static/media/GoaFishCurry.eb426a40.jpg";